import type { Child } from "@spork/s4p-server-sdk";

export function getChildLabel(child: Child) {
  return `${child.first_name} ${child.last_name}`;
}

export function joinChildLabels(children: Child[]) {
  return children.map(getChildLabel).join(", ");
}
